import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import List from '../List/List';
import Slider from '../Slider/Slider';
import * as styles from './VisualNav.css';
import { isDesktopWidth, isMobileWidth } from '../../helpers/Utils/mediaQuery';

const cx = classNames.bind(styles);

class VisualNav extends Component {
    static defaultProps = {
        datasource: [],
        itemsPerRow: 2,
        direction: '',
        navTheme: '',
        navTitle: '',
        automationId: '',
        adobeAudience: '',
        themeConfig: {},
        customTheme: '',
        galleryTheme: {},
        visualNavBodyClass: '',
        visNavWrapperBlock: '',
        onClickVisualNav: () => {},
        enableCarouselSlider: false,
        listParentRef: () => {},
        shopAllData: {},
        enableShopAllBtn: false,
        vizNavTheme: 'styleA',
        isFindstoreTheme: false,
        subHeadline: '',
        vizNavFasCustomTheme: '',
        headline: '',
        revieveModal: null,
    };

    static propTypes = {
        datasource: PropTypes.arrayOf(PropTypes.object),
        itemsPerRow: PropTypes.number,
        direction: PropTypes.string,
        navTheme: PropTypes.string,
        customTheme: PropTypes.string,
        navTitle: PropTypes.string,
        automationId: PropTypes.string,
        themeConfig: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        galleryTheme: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        visualNavBodyClass: PropTypes.string,
        visNavWrapperBlock: PropTypes.string,
        onClickVisualNav: PropTypes.func,
        enableCarouselSlider: PropTypes.bool,
        listParentRef: PropTypes.func,
        enableShopAllBtn: PropTypes.bool,
        shopAllData: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),
        vizNavTheme: PropTypes.string,
        isFindstoreTheme: PropTypes.bool,
        adobeAudience: PropTypes.string,
        subHeadline: PropTypes.string,
        vizNavFasCustomTheme: PropTypes.string,
        headline: PropTypes.string,
        revieveModal: PropTypes.func,
    };

    constructor() {
        super();
        this.state = {
            imageHeight: null,
            orientation: false,
        };
        this.imageRef = React.createRef();
    }

    UNSAFE_componentWillMount() {
        !__SERVER__ && this.handleOrientationChange();
    }

    componentDidMount() {
        /* istanbul ignore next */
        if (this.imageRef?.current?.complete) {
            this.setImageHeight(this.imageRef?.current?.offsetHeight);
        }
        this.handleOrientationChange();
        window.addEventListener('resize', () => this.handleOrientationChange());
    }

    componentWillUnmount() {
        window.removeEventListener('resize', () => this.handleOrientationChange());
    }

    handleOrientationChange = () => {
        const orientation =
            window &&
            window?.orientation &&
            Math.abs(window.orientation) === 90 &&
            window?.innerWidth >= 1280;

        this.setState({ orientation });
    };

    static getThemeConfig(themeConfig) {
        return {
            visNavGridTilesClass: styles.gridTiles,
            visNavWrapper: styles.wrapper,
            visNavTitled: styles.titledVisNav,
            visNavDeptTitle: styles.deptTitle,
            gridTilesList: styles.gridTilesList,
            sliderVisNavWrapper: styles.sliderVisNavWrapper,
            ...themeConfig,
        };
    }

    setImageHeight = (imageHeight) => {
        this.setState({ imageHeight });
    };

    analyticsTrackForDataSource = (data) => {
        const completeData = [];
        const { enableShopAllBtn, vizNavTheme, shopAllData, adobeAudience } = this.props;
        const pushShopAllDataCheck =
            enableShopAllBtn &&
            ((!isDesktopWidth() && vizNavTheme === 'styleC') ||
                (isMobileWidth() && vizNavTheme === 'styleB')); // display shopall button only for styleb and c
        const combinedData = pushShopAllDataCheck ? [...data, { ...shopAllData }] : [...data];
        combinedData.forEach((value) => {
            const { analyticsTag } = value;
            let formattedData = {};
            /* istanbul ignore next */
            if (value && analyticsTag) {
                let linkUrl = value.links;
                const matchForCmRe = /cm_re/.test(linkUrl.toLowerCase());
                if (!matchForCmRe && analyticsTag) {
                    const match = /.+\?.*/.test(linkUrl);
                    if (match) {
                        linkUrl += `&${analyticsTag}`;
                    } else {
                        linkUrl += `?${analyticsTag}`;
                    }
                } else if (adobeAudience) {
                    linkUrl = `${linkUrl}-_-${adobeAudience}`;
                }
                value.links = `${linkUrl}`;
                formattedData = value;
            } else {
                formattedData = value;
            }
            completeData.push(formattedData);
        });
        return completeData;
    };

    handleClickVisualNavItemLink = (dataItem) => {
        this.props.onClickVisualNav(dataItem);
    };

    render() {
        const {
            navTheme,
            navTitle,
            datasource,
            galleryTheme,
            visualNavBodyClass,
            visNavWrapperBlock,
            customTheme,
            itemsPerRow,
            direction,
            automationId,
            enableCarouselSlider,
            vizNavTheme,
            isFindstoreTheme,
            subHeadline,
            vizNavFasCustomTheme,
            headline,
            isCategoryPromo,
        } = this.props;
        const vizNavThemeFAS = isFindstoreTheme && vizNavFasCustomTheme;
        const themeConfig = VisualNav.getThemeConfig(this.props.themeConfig);
        let theme = cx(styles.visualNavList, navTitle && themeConfig.visNavTitled, vizNavThemeFAS);
        const rowItems = `itemsPerRow${itemsPerRow}`;

        if (!vizNavThemeFAS && navTheme) {
            theme = cx(navTheme);
        }

        const title = () => {
            if ((vizNavThemeFAS && headline) || navTitle) {
                return (
                    <section className={cx(styles.visualNavTitleWrapper, vizNavThemeFAS)}>
                        <h3
                            data-automation-id={automationId}
                            className={cx(styles.visualTitle, { visualTitleFAS: isFindstoreTheme })}
                        >
                            {(vizNavThemeFAS && headline) || navTitle}
                        </h3>
                        {isFindstoreTheme && subHeadline && (
                            <p className={cx('subHeadline')}>{subHeadline}</p>
                        )}
                    </section>
                );
            }
            return null;
        };

        const visualNavItemLinkContent = (dataItem, index) => {
            const imageTitle = dataItem.title && dataItem.title.trim();
            return (
                <>
                    {dataItem.image && (
                        <div
                            className={cx(
                                styles.imgBlock,
                                themeConfig.imgBlock,
                                galleryTheme.imgBlock,
                                { vizNavImgAutoSize: isFindstoreTheme }
                            )}
                        >
                            {dataItem.ext === 'mp4' ? (
                                <video
                                    playsInline
                                    autoPlay
                                    muted
                                    loop
                                    width="100%"
                                    height="100%"
                                    className={cx('videoTransition', themeConfig.videoTransition)}
                                >
                                    <source src={dataItem.image} type="video/mp4" />
                                </video>
                            ) : (
                                <img
                                    className={cx(
                                        'vizNavImage',
                                        themeConfig.vizNavImage,
                                        dataItem.className
                                    )}
                                    ref={index === 0 ? this.imageRef : null}
                                    src={dataItem.image}
                                    alt={dataItem.altText}
                                    title={imageTitle}
                                    width={dataItem.width}
                                    height={dataItem.height}
                                    onLoad={
                                        index === 0
                                            ? ({ target }) =>
                                                  this.setImageHeight(target?.offsetHeight)
                                            : null
                                    }
                                />
                            )}
                        </div>
                    )}
                    {dataItem?.title && (
                        <div className={themeConfig.visNavDeptTitle}>
                            <p>{dataItem.title}</p>
                            {dataItem.count && <p>{dataItem.count}</p>}
                        </div>
                    )}
                </>
            );
        };

        const visualNavItemHtmlRenderer = (dataItem, index) => {
            const RevieveModal = this.props.revieveModal;
            return (
                <div
                    className={cx(
                        styles.visualNavComponent,
                        themeConfig.visualNavComponent,
                        galleryTheme.visualNavComponent
                    )}
                >
                    <a
                        className={cx('deptLink', 'visualNavLink')}
                        href={dataItem.links}
                        aria-label={dataItem.title}
                        data-link-href={dataItem.links}
                        target={dataItem.openInNewTab ? '_blank' : '_self'}
                        onClick={this.handleClickVisualNavItemLink(dataItem)}
                        rel="noreferrer"
                    >
                        {this?.props?.revieveModal ? (
                            <RevieveModal
                                data={dataItem.analyticsTag}
                                componentToBeRendered={visualNavItemLinkContent(dataItem, index)}
                            />
                        ) : (
                            visualNavItemLinkContent(dataItem, index)
                        )}
                    </a>
                </div>
            );
        };

        const renderVisNav = () => {
            const pushShopAllDataCheck =
                this.props.enableShopAllBtn &&
                ((!isDesktopWidth() && vizNavTheme === 'styleC') ||
                    (isMobileWidth() && vizNavTheme === 'styleB')); // display shopall button only for styleb and c
            const shopAllbtnClass = cx('shopAllbtnClass');
            const visnavParentClass = pushShopAllDataCheck && shopAllbtnClass;
            return (
                <List
                    spacing="None"
                    listMainCustomClass={cx('visNavListMainCustomClass')}
                    listStyleClass={cx(
                        themeConfig.visNavGridTilesClass,
                        visnavParentClass,
                        'visNavCatDealListBlock',
                        { visNavFasCarousel: isFindstoreTheme }
                    )}
                    listBodyClass={cx(visualNavBodyClass, 'visualNavListBodyClass')}
                    itemStyleClass={cx(
                        themeConfig.gridTilesList,
                        rowItems,
                        { gridTilesListFAS: vizNavThemeFAS },
                        themeConfig.visNavGridTilesList && styles.gridTilesListItem
                    )}
                    datasource={this.analyticsTrackForDataSource(datasource)}
                    childRenderer={visualNavItemHtmlRenderer}
                    itemsPerRow={itemsPerRow}
                    direction={direction}
                    automationId={automationId}
                    listParentRef={this.props.listParentRef}
                />
            );
        };

        return (
            <div className={cx('coreVisualNav', theme, customTheme)}>
                {title()}
                <section className={cx('visNavSectionBlock', vizNavThemeFAS)}>
                    <div className={cx(themeConfig.visNavWrapper, visNavWrapperBlock)}>
                        {enableCarouselSlider && !(vizNavTheme === 'styleA') ? (
                            <Slider
                                wrapperClass={themeConfig.sliderVisNavWrapper}
                                contentWrapperClass={cx('visnavContentWrapper')}
                                imageHeight={this.state.imageHeight}
                                key={this.state.orientation}
                                isCategoryPromo={isCategoryPromo}
                            >
                                {renderVisNav()}
                            </Slider>
                        ) : (
                            renderVisNav()
                        )}
                    </div>
                </section>
            </div>
        );
    }
}

export default VisualNav;
